import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { PERMISSIONS } from "@/constants";
import { LOGOUT } from "@/store/auth.module";

import routes from "./routes";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes,
});

function businessPermissions(to, store) {
  try{
    return to.meta && to.meta.permission_scopes
      ? store.getters.user?.permissions.some((perm) =>
          to.meta.permission_scopes.includes(perm)
        ) || store.getters.user?.is_superuser
      : true;
  }catch(error){
    console.log(error);
  }
  return false;
}


router.beforeEach((toRoute, fromRoute, next) => {
  window.document.title = toRoute.meta.title;
  if (businessPermissions(toRoute, store)) {
    return next();
  } else {
    return next({ name: defaultRedirect() });
  }
  next();
});

export default router;

const defaultRedirect = function () {
  if (store.getters.isGuest) {
    store.dispatch(LOGOUT);
    return "login";
  }
  
  const userPermissions = store.getters.user?.permissions || [];
  
  if (userPermissions.includes(PERMISSIONS.ANALYTICS_ALL)) {
    return "companies"; // or "analytics" depending on your default
  }
  
  if (userPermissions.includes(PERMISSIONS.CHATBOT_ALL)) {
    return "chatbot";
  }
  
  if (userPermissions.includes(PERMISSIONS.FINANCING_ALL)) {
    return "financing";
  }
  
  store.dispatch(LOGOUT);
  return "login";
};